<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="">
            <div class="form-card-wrapper">
              <b-card header-tag="header">
                <template #header>
                  <b>Contenuto</b>
                </template>
                <b-card-text>
                  <b-row>
                    <div class="form-group">
                      <base-input
                        name="title"
                        vid="title"
                        label="Titolo"
                        v-model="form[rep].title"
                        placeholder="Inserisci un titolo"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-select
                        name="type"
                        label="Tipo"
                        v-model="form[rep].type"
                        :options="types"
                        :taggable="false"
                        :multiple="false"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-select
                        name="type"
                        label="Seleziona Preset"
                        v-model="form.preset"
                        :options="presets"
                        @input="onSelectPreset"
                        :taggable="false"
                        :multiple="false"
                      />
                    </div>
                    <div class="form-group mt-3 py-2">
                      <b-button
                        type="button"
                        class="btn--smaller"
                        variant="lisaweb"
                        @click="onLoadPreset"
                        size="sm"
                      >
                        Carica Preset
                      </b-button>
                    </div>
                  </b-row>
                  <div class="form-group mt-3">
                    <base-editor-sms
                      editor_id="sms_text_content"
                      :height="500"
                      v-model="form[rep].text_content"
                      @updateEditorContent="updateEditorContent"
                    />
                    <!-- <base-textarea
                      vid="text_content"
                      name="text_content"
                      label="Testo Template"
                      v-model="form[rep].text_content"
                      placeholder="Inserisci un testo"
                      :rules="{ required: true }"
                    /> -->
                  </div>
                </b-card-text>
              </b-card>
            </div>
            <div class="form-actions form-actions--sticky">
              <div class="inner-wrapper">
                <div>
                  <span
                    :title="`${
                      invalid
                        ? 'Compila correttamente i campi per poter salvare'
                        : 'Invia il form'
                    }`"
                  >
                    <b-button
                      @click="handleSubmit(onSubmit)"
                      type="button"
                      :disabled="invalid"
                      variant="lisaweb"
                      size="sm"
                    >
                      Salva
                    </b-button>
                  </span>
                </div>
                <b-button
                  @click="$router.back()"
                  size="sm"
                  class="btn--transparent"
                  title="Torna alla pagina precedente"
                >
                  <b-icon-chevron-double-left
                    font-scale="0.9"
                  ></b-icon-chevron-double-left>
                  Torna indietro
                </b-button>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
    <div class="is-saving-template" v-show="isSavingTemplate"></div>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import BaseSelect from "@/components/form/BaseSelect";
import BaseInput from "@/components/form/BaseInput";
// import BaseTextarea from "@/components/form/BaseTextarea.vue";
import BaseEditorSms from "@/components/form/BaseEditorSms";

export default {
  mixins: [ShortcutMixin, LisaComunicaMixin],
  data() {
    return {
      isLoading: false,
      isSavingTemplate: false,
      repository: "sms",
      id: this.$route.params.id,
      exceptions: ["title", "type"],
      types: [
        { value: "AVV_SCAD", text: "Avvisi scadenza" },
        { value: "MKTG", text: "Marketing" },
        { value: "SOLL", text: "Solleciti" },
        { value: "REN_PRO", text: "Rendiconti" },
      ],
      presets: [],
      form: {
        preset: null,
        sms: {
          title: null,
          type: null,
          text_content: null,
        },
      },
      updated_content: null,
    };
  },
  components: {
    BaseInput,
    BaseSelect,
    BaseEditorSms,
    // BaseTextarea,
  },
  methods: {
    updateEditorContent(contentHtml) {
      console.log("contentHtml", contentHtml);
      this.updated_content = contentHtml;
    },
    stripHtml(html) {
      // SMS templates don't support HTML: keep line breaks, drop tags,
      // and decode entities (&nbsp;, accented chars, &amp;, ...) via the DOM.
      const withBreaks = html
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/(p|div)>/gi, "\n");
      const tmp = document.createElement("div");
      tmp.innerHTML = withBreaks.replace(/<[^>]*>?/gm, "");
      return tmp.textContent.replace(/\u00a0/g, " ").trim();
    },
    onSubmit() {
      // this.form[this.rep].text_content = this.updated_content;
      const rawTextContent =
        this.get_html_from_iframe("sms_text_content") || "";
      const textContent = this.stripHtml(rawTextContent);
      if (
        !rawTextContent ||
        rawTextContent === `<p><br data-mce-bogus="1"></p>` ||
        rawTextContent === `<p></p>` ||
        !textContent
      ) {
        this.$showSnackbar({
          preset: "error",
          text: `C'è stato un problema durante il salvataggio. Ti preghiamo di riprovare più tardi.`,
        });
        return;
      }
      this.isSavingTemplate = true;
      this.form[this.rep].text_content = textContent;
      this.store()
        .then(() => {
          this.isSavingTemplate = false;
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Template Sms Creato`,
          });
          this.shortcut("lisacomunica_template", null, "#Sms", "filterSms");
        })
        .catch((error) => {
          let errMsg =
            error?.response?.data?.message || this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isSavingTemplate = false;
        });
    },
    setPresetOptions(presets) {
      this.presets = presets.map((preset) => {
        return {
          value: String(preset.id),
          text: preset.title,
          type: preset.type,
          text_content: preset.text_content,
        };
      });
    },
  },
  mounted() {
    this.isLoading = true;
    this.preset_all()
      .then((response) => {
        this.setPresetOptions(response.data.content);
        this.isLoading = false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
        this.isLoading = false;
      });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
